export default "__VITE_ASSET__96f6e2a6__"